import './notifications.css'
import React from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Strings from 'values/Strings';

const createNotification = ({
    type = 'info',
    warningTime = 2500, infoTime = 2500, successTime = 2500, errorTime = 2500,
    warningText = null, infoText = null, successText = null, errorText = null,
    warningCallback = () => { }, infoCallback = () => { }, successCallback = () => { }, errorCallback = () => { },
    warningPriority = false, infoPriority = false, successPriority = false, errorPriority = false,
}) => {
    return () => {
        switch (type) {
          case 'info':
              NotificationManager.info(infoText || 'Info notification', Strings.notificationsInfoTitle, infoTime, infoCallback, infoPriority);
              break;
          case 'success':
              NotificationManager.success(successText || 'Success notification', Strings.notificationsSuccessTitle, successTime, successCallback, successPriority);
              break;
          case 'warning':
              NotificationManager.warning(warningText || 'Warning notification', Strings.notificationsWarningTitle, warningTime, warningCallback, warningPriority);
              break;
          case 'error':
              NotificationManager.error(errorText || 'Error notification', Strings.notificationsErrorTitle, errorTime, errorCallback, errorPriority);
              break;
          default:
              NotificationManager.info(infoText || 'Info notification', Strings.notificationsInfoTitle, infoTime, infoCallback, infoPriority);
              break;
        }
    };
};


function Notifications() {
    return (
        <div className="notific__style">
            {/* <button className='btn btn-info'
                onClick={createNotification({ type: 'info' })}>Info
            </button>
            <hr />
            <button className='btn btn-success'
                onClick={createNotification({ type: 'success' })}>Success
            </button>
            <hr />
            <button className='btn btn-warning'
                onClick={createNotification({ type: 'warning' })}>Warning
            </button>
            <hr />
            <button className='btn btn-danger'
                onClick={createNotification({ type: 'error' })}>Error
            </button> */}
            <NotificationContainer />
        </div>
    )
}
export default Notifications;